// React hooks
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// Helpers i API servisi
import { useTranslate } from "helpers";

// Tipovi i konstante
import { VehicleContractSearchPageCmp, VehicleContractSearchPageProps } from "./types";
import { FLEET_VEHICLE_CONTRACT_SEARCH_PAGE_TITLE } from "ui/components/PageTitle/consts";

// UI komponente
import { Tabs } from "ui/components/Tabs";

// Moduli specifični za projekt
import { Routes as FleetVehicleRoutes } from "ui/modules/fleet/vehicles/navigation";

// Lokalne komponente
import { initialFleetVehicleDetailForm } from "services/api/fleet/vehicles/consts";
import { FleetVehicleDetailFormValues } from "services/api/fleet/vehicles/types";
import { getFleetVehicleAPI } from "services/api/fleet/vehicles/api";
import { Errors } from "services/forms/validation/types";
import TabMenu from "ui/modules/fleet/vehicles/pages/components/TabMenu/TabMenu";
import { VehicleTabHeader } from "ui/modules/fleet/vehicles/pages/components/VehicleTabHeader";
import VehicleContractSaleSearchPage from "./components/VehicleContractSaleSearchPage/VehicleContractSaleSearchPage";
import VehicleContractRentSearchPage from "./components/VehicleContractRentSearchPage/VehicleContractRentSearchPage";


const VehicleContractSearchPage: VehicleContractSearchPageCmp = (
  props: VehicleContractSearchPageProps
) => {

  const { id } = useParams();
  const { t } = useTranslate();

  const [formValues, setFormValues] = useState<FleetVehicleDetailFormValues>(
    initialFleetVehicleDetailForm
  );

  const [errors, setErrors] = useState<Errors>({});
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    if (id) {
      fetchVehicle(id);
    }
  }, [id]);

  const fetchVehicle = async (id: string) => {
    if (id === undefined) {
      setFormValues(initialFleetVehicleDetailForm);
      return;
    }

    setIsLoading(true);

    let result;
    try {
      result = await getFleetVehicleAPI(id);
    } catch {
      setIsLoading(false);
      return;
    }

    setFormValues(result);
    setIsLoading(false);

    setErrors({});
  };

  const handleStatusChange = useCallback(() => {
    if (id) fetchVehicle(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  if (!id) return <></>;

  return (
    <>
      <div >
        <div className="bg-white rounded-t-md">
          <VehicleTabHeader
            vehicleId={id}
            vehicle={formValues}
            title={t(FLEET_VEHICLE_CONTRACT_SEARCH_PAGE_TITLE.text)}
            icon={FLEET_VEHICLE_CONTRACT_SEARCH_PAGE_TITLE.icon}
            iconColor={FLEET_VEHICLE_CONTRACT_SEARCH_PAGE_TITLE.iconColor}
            onStatusChange={handleStatusChange}
          />
        </div>
        <TabMenu vehicleId={id} />
        <div className="py-3 px-4">
          <Tabs
            tabs={[
              {
                label: "Prodaja vozila",
                queryParam: "sale",
                content: (
                  <div>
                    <VehicleContractSaleSearchPage />
                  </div>
                ),
              },
              {
                label: "Najam vozila",
                queryParam: "rent",
                content: (
                  <div>
                    <VehicleContractRentSearchPage />
                  </div>
                ),
              },
            ]}
          />
        </div>
      </div>

    </>
  );
};

VehicleContractSearchPage.route = FleetVehicleRoutes.FleetVehicleContractSearchPageRouter;

export default VehicleContractSearchPage;
